export const environment = {
  production: false,
  apihost: 'https://sierraleone-stg-atom-server.revenuedev.org',
  apihostDomain : 'https://sierraleone-stg-atom-server.revenuedev.org',
  whitelistDomain: "sierraleone-stg-atom-server.revenuedev.org",
  blacklistDomain: "sierraleone-stg-atom-server.revenuedev.org/auth",
  accessToken: 'atom_access_token'
};